module.exports = __webpack_public_path__ + "images/category_lp/common/btn-parts@2x_9b615403f01d9236f10ba157b13eaac5.png";